module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-screen__content"
  }, [_c('div', {
    staticClass: "inner-screen__content__outer"
  }, [_c('div', {
    staticClass: "inner-screen__sidebar"
  }, [_c('ul', {
    staticClass: "tools"
  }, _vm._l((_vm.data.step_icons), function(icon, index) {
    return _c('li', [_c('a', {
      class: {
        active: _vm.currentStep == index + 1, visited: index + 1 < _vm.currentStep
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.changeStep(index + 1)
        }
      }
    }, [_c('div', {
      staticClass: "tools__line"
    }, [_c('span', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "tools__line__img"
    }, [_c('img', {
      attrs: {
        "src": icon.src
      }
    })])])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "inner-screen__video-cont"
  }, [_c('video-player', {
    ref: "videoPlayer",
    attrs: {
      "options": _vm.playerOptions
    },
    on: {
      "ended": function($event) {
        _vm.onPlayerEnded($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "inner-screen__description"
  }, [_c('div', {
    staticClass: "active",
    attrs: {
      "id": "desc1"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showDesc) ? _c('p', [_vm._v(_vm._s(_vm.description))]) : _vm._e()])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b229250"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoPage.vue
// module id = 569
// module chunks = 1